"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var react_2 = require("@emotion/react");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var StyledComponents_1 = require("../../Renderers/StyledComponents");

var ColumnMenu = function ColumnMenu(_ref) {
  var menuName = _ref.menuName,
      menuText = _ref.menuText,
      menuData = _ref.menuData,
      handleMenuOpen = _ref.handleMenuOpen,
      handleMenuItemClicked = _ref.handleMenuItemClicked,
      _ref$isExpanded = _ref.isExpanded,
      isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 100 : _ref$width,
      menuTop = _ref.menuTop,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      textColor = _ref.textColor,
      _ref$dividerStyle = _ref.dividerStyle,
      dividerStyle = _ref$dividerStyle === void 0 ? "line" : _ref$dividerStyle,
      menuFooter = _ref.menuFooter,
      value = _ref.value,
      breakPoint = _ref.breakPoint,
      _ref$addLeftOffset = _ref.addLeftOffset,
      addLeftOffset = _ref$addLeftOffset === void 0 ? 0 : _ref$addLeftOffset;

  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      hasMounted = _react_1$default$useS2[0],
      setHasMounted = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(0),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      textWidth = _react_1$default$useS4[0],
      setTextWidth = _react_1$default$useS4[1];

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors = theme.colors,
      _theme$colors$primary = _theme$colors.primary,
      white = _theme$colors$primary.white,
      secondaryBrand = _theme$colors$primary.secondaryBrand,
      lightGray = _theme$colors$primary.lightGray,
      lighterGray = _theme$colors$primary.lighterGray,
      primaryBrand = _theme$colors$primary.primaryBrand,
      disableColor = _theme$colors$primary.disable,
      blue = _theme$colors.secondary.blue;

  var _ref3 = (0, react_1.useState)({}),
      _ref4 = _slicedToArray(_ref3, 1),
      domNodeRefs = _ref4[0];

  var creatDomNodeRef = function creatDomNodeRef(fieldName) {
    domNodeRefs[fieldName] = react_1.default.createRef();
    return domNodeRefs[fieldName];
  };

  var caretSize = 10;
  var caretOffset = dividerStyle === "line" ? 0 : caretSize / 2;
  var leftOffset = textWidth && textWidth / 2 - width / 2 - caretOffset + addLeftOffset;
  var utilMenuColor = white;
  var utilMenuItemHoverColor = blue;
  react_1.default.useEffect(function () {
    setHasMounted(true);
  }, []); // trigger animation if on client side and is expanded prop, timeout is need to rehydration

  if (hasMounted && isExpanded) {
    setTimeout(function () {
      var _a, _b, _c;

      (_c = (_b = (_a = domNodeRefs[menuName]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.classList) === null || _c === void 0 ? void 0 : _c.add("animExpand");
    }, 100);
  }

  var MenuContainer = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t", ";\n\t"])), (0, StyledComponents_1.utilityMenuDropDownStyles)(utilMenuColor, lighterGray)); // Note: this style cannot be shared - it has to reside here

  var containerStyles = function containerStyles(leftOffset, topOffset, width) {
    return (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tposition: absolute;\n\t\t\tleft: ", "px;\n\t\t\ttop: ", "px;\n\t\t\tmin-width: ", ";\n\t\t\twidth: 100%;\n\t\t\tcursor: initial;\n\t\t"])), leftOffset, topOffset, width && width + "px;");
  };

  var renderMenuColumns = function renderMenuColumns(menuData) {
    var inRecursion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      direction: "row",
      justifyContent: "space-between",
      className: "menu-column-outer",
      css: (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\t\t\tcursor: initial;\n\t\t\t\t\tpadding-top: 10px;\n\t\t\t\t\tpadding-right: 10px;\n\t\t\t\t"]))),
      children: menuData.map(function (column, colIndex) {
        return (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          className: "menu-column-inner",
          direction: "column",
          css: (0, react_2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tcursor: initial;\n\t\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t\t"]))),
          children: column === null || column === void 0 ? void 0 : column.map(function (link, linkIndex) {
            return link.addButton ? (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              weight: link.appearsBold ? "bold" : "normal",
              size: link.appearsBold ? "md" : "sm",
              breakPoint: breakPoint,
              color: theme.colors.primary.header,
              type: "primary",
              css: link.appearsUnderlined ? (0, react_2.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\tborder-bottom: 1px solid\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t", ";\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-bottom: 8px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-left: 20px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding: 30px 0px 12px 0px;\n\t\t\t\t\t\t\t\t\t\t\t\t\twidth: 250px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tbox-sizing: border-box;\n\t\t\t\t\t\t\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\t\t\t\t\t\t\t:hover {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t  "])), theme.colors.primary.lighterGray, utilMenuItemHoverColor) : (0, react_2.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding: 30px 20px 5px 20px;\n\t\t\t\t\t\t\t\t\t\t\t\t\twidth: 250px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tbox-sizing: border-box;\n\t\t\t\t\t\t\t\t\t\t\t\t\t:hover {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\t\t\t\t\t  "])), utilMenuItemHoverColor),
              children: (0, jsx_runtime_1.jsxs)("span", {
                onClick: function onClick(e) {
                  if (link.url && link.url.length > 0) {
                    e.stopPropagation();
                    link.url && handleMenuItemClicked(menuName, link.url);
                  }
                },
                "data-testid": "utility-menu-inner-addButton-".concat(link.label),
                children: [(0, jsx_runtime_1.jsx)("span", {
                  css: (0, react_2.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\tbackground-color: ", ";\n\t\t\t\t\t\t\t\t\t\t\t\twidth: 24px;\n\t\t\t\t\t\t\t\t\t\t\t\theight: 24px;\n\t\t\t\t\t\t\t\t\t\t\t\tborder-radius: 24px;\n\t\t\t\t\t\t\t\t\t\t\t\tpadding-left: 2px;\n\t\t\t\t\t\t\t\t\t\t\t\tbox-sizing: border-box;\n\t\t\t\t\t\t\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t\t\t\t\t\t\tline-height: 25px;\n\t\t\t\t\t\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t\t\t\t\t\t\tmargin-right: 12px;\n\t\t\t\t\t\t\t\t\t\t\t\tvertical-align: middle;\n\t\t\t\t\t\t\t\t\t\t\t"])), theme.colors.primary.primaryBrand),
                  children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                    icon: "chevron-right",
                    css: (0, react_2.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\t\t\t\t\t\t"]))),
                    color: theme.colors.primary.white,
                    size: "xs",
                    dataTestId: "utility-menu-items-addButton-icon"
                  })
                }), (0, jsx_runtime_1.jsx)("span", {
                  css: (0, react_2.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t\t\t\t\t\t\twidth: calc(100% - 36px);\n\t\t\t\t\t\t\t\t\t\t\t\tvertical-align: middle;\n\t\t\t\t\t\t\t\t\t\t\t"]))),
                  children: link.label
                })]
              })
            }, linkIndex) : (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              weight: link.appearsBold ? "bold" : "normal",
              size: link.appearsBold ? "md" : "sm",
              breakPoint: breakPoint,
              color: theme.colors.primary.header,
              type: "primary",
              css: link.appearsUnderlined ? (0, react_2.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\tborder-bottom: 1px solid\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t", ";\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-bottom: 8px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-left: 20px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding: 5px 0px 12px 0px;\n\t\t\t\t\t\t\t\t\t\t\t\t\twidth: 250px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tbox-sizing: border-box;\n\t\t\t\t\t\t\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\t\t\t\t\t\t\t:hover {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t  "])), theme.colors.primary.lighterGray, utilMenuItemHoverColor) : (0, react_2.css)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding: 5px 20px 5px 20px;\n\t\t\t\t\t\t\t\t\t\t\t\t\twidth: 250px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tbox-sizing: border-box;\n\t\t\t\t\t\t\t\t\t\t\t\t\t:hover {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\t\t\t\t\t  "])), utilMenuItemHoverColor),
              children: (0, jsx_runtime_1.jsx)("span", {
                onClick: function onClick(e) {
                  if (link.url && link.url.length > 0) {
                    e.stopPropagation();
                    link.url && handleMenuItemClicked(menuName, link.url);
                  }
                },
                "data-testid": "utility-menu-inner-".concat(link.label),
                children: link.label
              })
            }, linkIndex);
          })
        }, "col-".concat(colIndex));
      })
    });
  };

  return (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
    className: "utility-menu-root",
    direction: "column",
    css: (0, react_2.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n\t\t\t\tposition: relative;\n\t\t\t\t:hover {\n\t\t\t\t\t", "\n\t\t\t\t}\n\t\t\t\t", "\n\t\t\t"])), !disabled && (0, StyledComponents_1.UtilityItemHilite)(utilMenuItemHoverColor), !disabled && isExpanded && (0, StyledComponents_1.UtilityItemHilite)(utilMenuItemHoverColor)),
    children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      className: "utility-menu-item-wrapper",
      onClick: function onClick(e) {
        var _a;

        var w = (_a = e.target) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width;
        setTextWidth(w);
        e.stopPropagation();
        handleMenuOpen(menuName);
      },
      justifyContent: "flex-end",
      css: (0, react_2.css)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n\t\t\t\t\t", "\n\t\t\t\t\t@media only screen and (max-width: ", "px) {\n\t\t\t\t\t\tpadding-top: 2px;\n\t\t\t\t\t}\n\t\t\t\t"])), disabled && "pointer-events:none;", breakPoint),
      dataTestId: "header-utility-menu-item-wrapper",
      children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        css: (0, react_2.css)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tflex-basis: min-content;\n\t\t\t\t\t"]))),
        children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          variant: "span",
          breakPoint: breakPoint,
          css: (0, react_2.css)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tpointer-events: none;\n\t\t\t\t\t\t"]))),
          className: "utility-item-name",
          size: "sm",
          color: textColor || secondaryBrand,
          dataTestId: "header-utility-item-".concat(menuText),
          children: (0, jsx_runtime_1.jsx)(StyledComponents_1.TextDisplay, {
            css: (0, react_2.css)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\twhite-space: ", ";\n\t\t\t\t\t\t\t"])), (menuText === null || menuText === void 0 ? void 0 : menuText.indexOf("|")) !== -1 ? "pre-line" : "nowrap"),
            disabled: disabled,
            disableColor: disableColor,
            breakPoint: breakPoint,
            children: (menuText === null || menuText === void 0 ? void 0 : menuText.indexOf("|")) !== -1 ? menuText === null || menuText === void 0 ? void 0 : menuText.split(" | ").join("\n") : menuText
          })
        })
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        className: "utility-item-icon-wrapper",
        alignSelf: "center",
        shrink: 0,
        grow: 1,
        css: (0, StyledComponents_1.utilMenuItemIcon)(breakPoint),
        children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
          className: "icon",
          icon: "chevron-down",
          size: "xs",
          color: disabled ? disableColor : lightGray,
          css: (0, react_2.css)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t@media only screen and (max-width: ", "px) {\n\t\t\t\t\t\t\t\tpadding: 1px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t"])), breakPoint),
          dataTestId: "utility-item-chevron-down-icon"
        })
      })]
    }), isExpanded && menuData.length ? (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      className: "content-container",
      css: containerStyles(leftOffset, menuTop, width),
      direction: "column",
      children: [dividerStyle === "line" && (0, jsx_runtime_1.jsx)(StyledComponents_1.UtilityMenuDivider, {
        backgroundColor: primaryBrand,
        dividerWidth: Math.ceil(textWidth),
        addLeftOffset: addLeftOffset,
        className: "divider-line"
      }), dividerStyle === "caret" && (0, jsx_runtime_1.jsx)(StyledComponents_1.UtilityMenuCaret, {
        caretSize: caretSize,
        utilMenuColor: utilMenuColor,
        className: "caret"
      }), (0, jsx_runtime_1.jsxs)(MenuContainer, {
        ref: creatDomNodeRef(menuName),
        className: "".concat(menuName, " drop-down"),
        children: [renderMenuColumns(menuData), menuFooter && (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          alignItems: "center",
          justifyContent: menuData.length > 1 ? "flex-end" : "center",
          css: (0, react_2.css)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\tborder-top: 1px solid ", ";\n\t\t\t\t\t\t\t\t\tpadding: 20px 0px 10px 0px;\n\t\t\t\t\t\t\t\t"])), lighterGray),
          dataTestId: "utility-menu-inner-footer",
          children: menuFooter
        })]
      })]
    }) : null]
  });
};

exports.default = ColumnMenu;